import React from 'react'

import AppraisalForm from '../components/appraisal-form'

const AgentProfileContact = ({ title, content, team, additionalEmails }) => {
  
  let emails = team?.teamDetails?.email || '' 
  emails += additionalEmails ? ', ' + additionalEmails : ''

  return (
    <section className='contact' id='contact-form'>
      <div className='contact__inner'>
        <div className='contact__content'>
          <div className='contact__menu'>
            <ul>
              <li>{ 'Contact' }</li>
            </ul>
          </div>
          <div className='contact__form'>
            <h2> {title}</h2>
            <div dangerouslySetInnerHTML={{ __html: content }} />
            <AppraisalForm email={emails} discussed={true} type="Sales" />
          </div>
        </div>
      </div>
    </section>
  )
}

AgentProfileContact.defaultProps = {
  title: 'Contact',
}

export default AgentProfileContact